(function () {
    'use strict';

    angular
        .module('core.components', []);

    angular
        .module('core.directives', []);

    angular
        .module('core.filters', []);

    angular
        .module('core.interceptors', []);

    angular
        .module('core.routes', []);

    angular
        .module('core.services', []);
}());